import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {from, Observable} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {ContractsService} from 'src/app/services/contracts.service';

@Component({
  selector: 'aw-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss']
})
export class FileInputComponent implements OnInit {

  @ViewChild('fileInput') fileInput: ElementRef;
  selectedFile: File | null = null;
  contractId: number;
  uploadProgress: number = 0;
  isUploading: boolean = false;
  fileUploaded: boolean = false;
  @Output() fileLoaded = new EventEmitter<any>();

  constructor(
    private contractService: ContractsService,
    private router: Router,
    private snackbar: MatSnackBar,
  ) {
  }

  ngOnInit() {
    this.contractId = parseInt(this.router.url.split("/")[3]);
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.uploadProgress = 0;
      this.fileUploaded = false;
      this.fileUploaded = false;
    } else {
      this.selectedFile = null;
      this.uploadProgress = 0;
      this.fileUploaded = false;
      this.fileUploaded = false;
    }
    console.log(this.selectedFile);
  }

  /*onFileLoad() {
    if (this.selectedFile) {
      this.contractService.getUploadSignedUrl(this.contractId, this.selectedFile.name, this.selectedFile.size).subscribe(response => {

        console.log('----------------------------------->', response);
        let obs = new Observable<any>();
        obs = from(this.selectedFile.arrayBuffer()).pipe(
          switchMap(fileBuffer => {
            return this.contractService.uploadFile(fileBuffer, this.selectedFile.name, this.selectedFile.type, response.data.url, response.data.fields);
          })
        );

        obs.subscribe(() => {
          this.selectedFile = null;
          this.snackbar.open('File Uploaded!', 'Close', {
            duration: 2000
          });
          this.fileLoaded.emit();
        }, () => {
          this.snackbar.open('File NOT Uploaded!', 'Close', {
            duration: 2000
          });
        });


        
      })
    }
  }*/
  onFileLoad() {
  if (this.selectedFile) {
    this.isUploading = true;
    this.uploadProgress = 0;
    
    this.contractService.getUploadSignedUrl(this.contractId, this.selectedFile.name, this.selectedFile.size).subscribe({
      next: (response) => {
        this.selectedFile!.arrayBuffer().then(fileBuffer => {
          this.contractService.uploadFileWithProgress(
            fileBuffer, 
            this.selectedFile!.name, 
            this.selectedFile!.type, 
            response.data.url, 
            response.data.fields
          ).subscribe({
            next: (event) => {
              if (event.type === 1) { // HttpEventType.Sent
                console.log('Upload started');
              } else if (event.type === 3) { // HttpEventType.UploadProgress
                this.uploadProgress = Math.round(100 * event.loaded / event.total!);
                console.log(`Upload progress: ${this.uploadProgress}%`);
              } else if (event.type === 4) { // HttpEventType.Response
                this.uploadProgress = 100;
                this.isUploading = false; // Only stop uploading, don't clear file
                this.fileUploaded = true;
                this.snackbar.open('File Uploaded!', 'Close', { duration: 2000 });
                this.fileLoaded.emit();
              }
            },
            error: (error) => {
              console.error('Upload failed:', error);
              this.isUploading = false;
              this.uploadProgress = 0;
              this.snackbar.open('File NOT Uploaded!', 'Close', { duration: 2000 });
            }
          });
        });
      },
      error: (error) => {
        console.error('Failed to get signed URL:', error);
        this.isUploading = false;
      }
    });
  }
}


}
